import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { fetchPostData } from './api';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import { addDays,startOfYear } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { createStaticRanges, defaultStaticRanges } from 'react-date-range';


const FileUploadAndProcess = () => {
  const clickCountRef = useRef(0);




  const today = new Date();
  const now = new Date(); 
  const [state, setState] = useState([
    // {
    //   startDate: addDays(new Date(), -7),
    //   endDate: new Date(),
    //   key: 'selection'
    // }
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);


  const customStaticRanges = [
    ...defaultStaticRanges,
    {
      label: 'Last 7 Days',
      range: () => ({
        startDate: addDays(new Date(), -6),
        endDate: new Date(),
      }),
      isSelected(range) {
        const now = new Date();
        const start = addDays(now, -6);
        return (
          range.startDate.toDateString() === start.toDateString() &&
          range.endDate.toDateString() === now.toDateString()
        );
      },
    },
    {
      label: 'Last 30 Days',
      range: () => ({
        startDate: addDays(new Date(), -29),
        endDate: new Date(),
      }),
      isSelected(range) {
        const now = new Date();
        const start = addDays(now, -29);
        return (
          range.startDate.toDateString() === start.toDateString() &&
          range.endDate.toDateString() === now.toDateString()
        );
      },
    },
    {
      label: 'This Year',
      range: () => {
        const now = new Date();
        return {
          startDate: startOfYear(now),
          endDate: now,
        };
      },
      isSelected(range) {
        const now = new Date();
        const start = startOfYear(now);
        return (
          range.startDate.toDateString() === start.toDateString() &&
          range.endDate.toDateString() === now.toDateString()
        );
      },
    }
  ];
  
  const [showPicker, setShowPicker] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [loading, setLoading] = useState(false);
  const gridRef = useRef(null);

  const columnsStaffing = [
    {
      headerName: "S.No",
      valueGetter: "node.rowIndex + 1",
      width: 60,
    },
    {
      headerName: "Action",
      field: "id",
      width: 100,
      cellRenderer: (params) => (
        <a
          className="btn btn-sm btn-primary"
          href={`https://staffing.nithrajobs.com/paidEmployee?i=${params.value}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      ),
    },
    ...Object.keys(excelData[0] || {})
      .filter((key) => !['inv_year', 'inv_no', 'email'].includes(key))
      .map((key) => ({
        headerName: key,
        field: key,
        sortable: true,
        resizable: true,
      }))
  ];

  const handleDownload = () => {
    const optionsCSV = {
      fileName: 'employee_Deatails_' + new Date().toLocaleTimeString() + '.csv',
    };
    gridRef.current.api.exportDataAsCsv(optionsCSV);
  };

  const handleDateSelect = async (range) => {
    const { startDate, endDate } = range[0];
    const formattedStart = moment(startDate).format("YYYY-MM-DD 00:00:00");
    const formattedEnd = moment(endDate).format("YYYY-MM-DD 23:59:59");

    try {
      setLoading(true);
      const response = await fetchPostData('/billing/get/employee-payments', {
        startDate: formattedStart,
        endDate: formattedEnd
      }, {
        'Content-Type': 'application/json'
      });
      if (response.success) {
        setExcelData(response.data);
      } else {
        console.error("Fetch failed");
      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleDateSelect(state);
  }, []);
  
  useEffect(() => {
    // 🎨 Inject custom styles only for this component
    const style = document.createElement('style');
    style.innerHTML = `
      .custom-date-picker .rdrDateDisplay {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  
    return () => {  
      document.head.removeChild(style); // 🧹 Cleanup 
    };
  }, []);
  return (
    <div className="container mt-5">
      <h2>Employee Payment Details</h2>

      <div className="mb-3">
        <Button variant="outline-primary" onClick={() => setShowPicker(!showPicker)}>
          📅 {moment(state[0].startDate).format('MMMM D, YYYY')} - {moment(state[0].endDate).format('MMMM D, YYYY')}
        </Button>



        {showPicker && (
          <div className="position-absolute bg-white  shadow" style={{ zIndex: 100, borderRadius: '10px' }}>
            {/* <DateRangePicker
              onChange={(item) => {
                setState([item.selection]);
                handleDateSelect([item.selection]);
                setShowPicker(false);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={state}
              direction="horizontal"
              rangeColors={["#3d91ff"]}
            /> */}
<div className='custom-date-picker'
  style={{
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
  }}
>
<DateRangePicker  
  // onChange={(item) => {
  //   setState([item.selection]);
  //   handleDateSelect([item.selection]);
  //   setShowPicker(false);
  // }}

  // onChange={(item) => {
  //   setState([item.selection]);
  
  //   const { startDate, endDate } = item.selection;
  //   if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
  //     handleDateSelect([item.selection]);
  //     setShowPicker(false); // ✅ only close after full range is selected
  //   }
  // }}
  

  
     onChange={(item) => {
  const { startDate, endDate } = item.selection;

  setState([item.selection]); // ⬅️ update local calendar view

  const isSameDay = startDate.getTime() === endDate.getTime;

  clickCountRef.current += 1;

  // ✅ Only proceed after 2 clicks (or same-day selection)
  if (clickCountRef.current === 2 || isSameDay) {
    handleDateSelect([item.selection]);  // send API
    setShowPicker(false);                // close the picker
    clickCountRef.current = 0;          // reset click counter
  }
}}
  showSelectionPreview={true}
  moveRangeOnFirstSelection={false}
  months={2}
  ranges={state}
  direction="horizontal"
  rangeColors={["#3d91ff"]}
  staticRanges={customStaticRanges}
  inputRanges={[]}
  minDate={new Date(2000, 0, 1)} // Optional - allow earlier
  maxDate={new Date(2100, 11, 31)} 
/>
</div>
          </div>
        )}
      </div>

      {excelData.length > 0 && (
        <div className="mt-4">
          <Button className="mb-3" variant="primary" onClick={handleDownload}>
            Download CSV
          </Button>
          <div className="ag-theme-alpine">
            <AgGridReact
              ref={gridRef}
              columnDefs={columnsStaffing}
              rowData={excelData}
              pagination={true}
              domLayout="autoHeight"
              modules={[ClientSideRowModelModule]}
            />
          </div>
        </div>
      )}
    </div>
  );
};




export default FileUploadAndProcess;
